import {subscribe} from 'dna-react-ioc'
import {IGlobalLoaderStore} from './IGlobalLoaderStore'
import {GlobalLoaderStoreSymbol} from './index'

export const getGlobalLoaderStore = (): IGlobalLoaderStore => {
    return subscribe<IGlobalLoaderStore>(GlobalLoaderStoreSymbol)
}
